import { useContext, useEffect, useState } from "react";
import "@aws-amplify/ui-react/styles.css";
import { I18n } from "aws-amplify/utils";
import { strings } from "./strings";
import {
	BrowserRouter as Router,
	Route,
	Routes,
	useLocation,
} from "react-router-dom";
import ResetPasswordSuccess from "./routes/resetPasswordSuccess";
import SignIn from "./routes/signIn";
import SignUp from "./routes/signUp";
import ForgotPassword from "./routes/forgotPassword";
import ConfirmForgotPassword from "./routes/confirmForgotPassword";
import Logout from "./routes/logout";
import Profile from "./routes/profile";
import { fetchAuthSession } from "aws-amplify/auth";
import { Context } from "./contexts/context";
import SignUpSuccess from "./routes/signUpSuccess";
import AccountActivationSuccess from "./routes/accountActivationSuccess";
import AccountActivation from "./routes/accountActivation";
import SignInSuccess from "./routes/signInSuccess";
import {
	clearStoredAuthData,
	getStoredAuthData,
	persistAuthData,
} from "./utils/authStorage";

I18n.putVocabularies(strings);

const AuthenticatedRoutes = () => (
	<Routes>
		<Route
			path="/accountActivationSuccess"
			element={<AccountActivationSuccess />}
		/>
		<Route path="/signInSuccess" element={<SignInSuccess />} />
		<Route path="/logout" element={<Logout />} />
		<Route path="*" element={<Profile />} />
	</Routes>
);

const GuestRoutes = () => (
	<Routes>
		<Route path="/forgotPassword" element={<ForgotPassword />} />
		<Route
			path="/confirmForgotPassword"
			element={<ConfirmForgotPassword />}
		/>
		<Route path="/resetPasswordSuccess" element={<ResetPasswordSuccess />} />
		<Route path="/accountActivation" element={<AccountActivation />} />
		<Route path="/signUp" element={<SignUp />} />
		<Route path="/signUpSuccess" element={<SignUpSuccess />} />
		<Route path="/logout" element={<Logout />} />
		<Route path="*" element={<SignIn />} />
	</Routes>
);

const AppRoutes = () => {
	const { updateUserEmail } = useContext(Context);
	const [isAuthenticated, setIsAuthenticated] = useState(false);
	const location = useLocation();

	useEffect(() => {
		const checkAuthState = async () => {
			try {
				const session = await fetchAuthSession();
				const authData = await getStoredAuthData(session);

				if (!authData.idToken) {
					await clearStoredAuthData();
					setIsAuthenticated(false);
					return;
				}

				updateUserEmail(authData.userEmail);
				await persistAuthData(authData);
				setIsAuthenticated(true);
			} catch (error) {
				await clearStoredAuthData();
				setIsAuthenticated(false);
			}
		};

		checkAuthState();
	}, [location.pathname, location.search, updateUserEmail]);

	return isAuthenticated ? <AuthenticatedRoutes /> : <GuestRoutes />;
};

const App = () => {
	return (
		<Router>
			<AppRoutes />
		</Router>
	);
};

export default App;
